var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPenEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 16 14",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.125,
    transform: "translate(1.25 1.000035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.7842501.46571466v.00000006c.621039.62143725.621039 1.628565-.0000001 2.25l-7.49024999 7.49024998h-.00000001c-.19221525.1922018-.4330455.32856-.69675.3945l-2.59725.6495.6495-2.59724997.00000003-.00000012c.06593985-.2637045.20229825-.50453475.3945-.69675l7.491-7.49025.00000006-.00000006c.62117925-.62095275 1.62807001-.62095275 2.24925001.00000011z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.375 4.124965-2.25-2.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5000001 10.4999647-.8205.8205-.0000001.0000001c-.906165.905925-2.375085.905925-3.28125003-.0000002l-.00000003-.0000001c-.907275-.903945-2.374725-.903945-3.282.0000001"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m-1-2h18v18h-18z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenEdit);
export default __webpack_public_path__ + "static/media/pen-edit.d98a61c5d6468c5b06fa5cb227104357.svg";
export { ForwardRef as ReactComponent };